<div class="edit-row" [ngClass]="{'no-margin-top' : noMarginTop}">
  <div class="edit-button flex-basis-50 fs-16 flex justify-content-center" (click)="editClicked.emit()">
    <span class="align-self-center">Edit</span>
  </div>
  <div class="delete-button flex-basis-50 fs-16 flex justify-content-center" (click)="deleteClicked.emit()">
    <span class="align-self-center">Delete</span>
  </div>
</div>
